module.exports = __webpack_public_path__ + "static/media/Truck_SUV.de487ae7.png";